import {Filter, PropertyTypeQueryKey} from "../data/Filter/Filter.config";
import {ObjectInterfaceWithCity} from "../interfaces/ObjectInterface";

export function mapPropertyType(object: ObjectInterfaceWithCity) {
	const propertyFilter = Object.values(Filter).filter(
		(obj) => obj.queryKey === PropertyTypeQueryKey
	);
	const label = propertyFilter.find((p) =>
		p.values?.includes(object.property_type)
	)?.label;
	return label;
}
